import { getInitialState } from "../../utils";
import ActionTypes from "../actions/ActionTypes";
const initialState = {
  inventoriesList: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_INVENTORIES_LIST:
      return setInventoriesList(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_INVENTORIES:
      return setActiveFilters(state, action);
    case ActionTypes.RESET_STATE_INVENTORIES:
      return resetInventories(state, action);
    default:
      return state;
  }
}

const setInventoriesList = (state, action) => {
  return {
    ...state,
    inventoriesList: action.payload, //getPath(action.payload, "", []),
  };
};

const resetInventories = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
